export const LOADING_TEXT = 'Loading...'
export const PAGE_TITLE = 'Leader Dashboard'
